var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRateCandidate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.233,
    height: 167.661,
    viewBox: "0 0 133.233 167.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 76.399,
    height: 47.579,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22272",
    "data-name": "Group 22272",
    transform: "translate(18825.531 22097.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22269",
    "data-name": "Group 22269",
    transform: "translate(-18825.35 -21943.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11341",
    "data-name": "Path 11341",
    d: "M133.052,351.373c0,3.732-29.785,6.757-66.526,6.757S0,355.105,0,351.373s29.785-6.757,66.526-6.757,66.526,3.026,66.526,6.757",
    transform: "translate(0 -344.616)",
    fill: "#7586ec",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22271",
    "data-name": "Group 22271",
    transform: "translate(-18813.998 -22097.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11246",
    "data-name": "Path 11246",
    d: "M323.464,451.117A8.116,8.116,0,1,1,315.348,443a8.116,8.116,0,0,1,8.116,8.116",
    transform: "translate(-296.78 -341.054)",
    fill: "#dfe0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11247",
    "data-name": "Path 11247",
    d: "M327.327,455.473l-2.844,2.263a.277.277,0,0,0-.094.291l.971,3.5a.419.419,0,0,1-.634.461l-3.031-2.006a.277.277,0,0,0-.306,0l-3.031,2.006a.419.419,0,0,1-.635-.461l.971-3.5a.277.277,0,0,0-.094-.291l-2.845-2.263a.419.419,0,0,1,.242-.746l3.632-.158a.276.276,0,0,0,.247-.18l1.273-3.4a.419.419,0,0,1,.784,0l1.273,3.4a.277.277,0,0,0,.247.18l3.632.158a.419.419,0,0,1,.242.746",
    transform: "translate(-302.972 -346.763)",
    fill: "#f0f0fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11265",
    "data-name": "Path 11265",
    d: "M605.491,451.117A8.116,8.116,0,1,1,597.375,443a8.116,8.116,0,0,1,8.116,8.116",
    transform: "translate(-505.599 -341.054)",
    fill: "#dfe0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11266",
    "data-name": "Path 11266",
    d: "M609.353,455.473l-2.844,2.263a.277.277,0,0,0-.094.291l.971,3.5a.419.419,0,0,1-.634.461l-3.031-2.006a.277.277,0,0,0-.306,0l-3.031,2.006a.419.419,0,0,1-.635-.461l.971-3.5a.277.277,0,0,0-.094-.291l-2.845-2.263a.419.419,0,0,1,.242-.746l3.632-.158a.276.276,0,0,0,.247-.18l1.273-3.4a.419.419,0,0,1,.784,0l1.273,3.4a.277.277,0,0,0,.247.18l3.631.158a.419.419,0,0,1,.242.746",
    transform: "translate(-511.791 -346.763)",
    fill: "#f0f0fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11286",
    "data-name": "Path 11286",
    d: "M359.707,82H284.571a17.624,17.624,0,0,0-17.6,17.6v104.7a17.625,17.625,0,0,0,17.6,17.605h75.137a17.625,17.625,0,0,0,17.6-17.605V99.607a17.624,17.624,0,0,0-17.6-17.6",
    transform: "translate(-266.967 -73.763)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22263",
    "data-name": "Group 22263",
    transform: "translate(16.973 66.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22262",
    "data-name": "Group 22262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22261",
    "data-name": "Group 22261",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11287",
    "data-name": "Path 11287",
    d: "M334.579,473.22h56.7a2.227,2.227,0,0,1,0,4.453h-56.7a2.227,2.227,0,1,1,0-4.453",
    transform: "translate(-332.352 -430.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11288",
    "data-name": "Path 11288",
    d: "M406.525,353.071H334.579a2.226,2.226,0,0,1-2.226-2.227h0a2.227,2.227,0,0,1,2.226-2.227h71.946a2.227,2.227,0,0,1,2.227,2.227h0a2.227,2.227,0,0,1-2.227,2.227",
    transform: "translate(-332.353 -337.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    "data-name": "Path 11289",
    d: "M406.525,394.6H334.579a2.226,2.226,0,0,1-2.226-2.227h0a2.227,2.227,0,0,1,2.226-2.227h71.946a2.227,2.227,0,0,1,2.227,2.227h0a2.227,2.227,0,0,1-2.227,2.227",
    transform: "translate(-332.353 -368.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11290",
    "data-name": "Path 11290",
    d: "M406.525,436.139H334.579a2.226,2.226,0,0,1-2.226-2.227h0a2.227,2.227,0,0,1,2.226-2.227h71.946a2.227,2.227,0,0,1,2.227,2.227h0a2.227,2.227,0,0,1-2.227,2.227",
    transform: "translate(-332.353 -399.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11291",
    "data-name": "Path 11291",
    d: "M406.525,311.537H334.579a2.226,2.226,0,0,1-2.226-2.227h0a2.227,2.227,0,0,1,2.226-2.227h71.946a2.227,2.227,0,0,1,2.227,2.227h0a2.227,2.227,0,0,1-2.227,2.227",
    transform: "translate(-332.353 -307.083)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11292",
    "data-name": "Path 11292",
    d: "M319.917,525.119a8.543,8.543,0,1,1-8.543-8.543,8.543,8.543,0,0,1,8.543,8.543",
    transform: "translate(-293.521 -395.53)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11293",
    "data-name": "Path 11293",
    d: "M323.982,529.7l-2.994,2.382a.292.292,0,0,0-.1.306l1.022,3.687a.441.441,0,0,1-.668.485l-3.191-2.112a.291.291,0,0,0-.322,0l-3.19,2.112a.441.441,0,0,1-.668-.485l1.022-3.687a.292.292,0,0,0-.1-.306L311.8,529.7a.441.441,0,0,1,.255-.785l3.823-.167a.292.292,0,0,0,.26-.189l1.34-3.584a.441.441,0,0,1,.826,0l1.34,3.584a.291.291,0,0,0,.26.189l3.823.167a.441.441,0,0,1,.255.785",
    transform: "translate(-300.039 -401.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11294",
    "data-name": "Path 11294",
    d: "M391.8,525.119a8.543,8.543,0,1,1-8.543-8.543,8.543,8.543,0,0,1,8.543,8.543",
    transform: "translate(-346.746 -395.53)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11295",
    "data-name": "Path 11295",
    d: "M395.867,529.7l-2.994,2.382a.292.292,0,0,0-.1.306l1.022,3.687a.44.44,0,0,1-.668.485l-3.191-2.112a.291.291,0,0,0-.322,0l-3.191,2.112a.441.441,0,0,1-.668-.485l1.022-3.687a.291.291,0,0,0-.1-.306l-2.994-2.382a.441.441,0,0,1,.255-.785l3.823-.167a.292.292,0,0,0,.26-.189l1.34-3.584a.441.441,0,0,1,.826,0l1.34,3.584a.291.291,0,0,0,.26.189l3.823.167a.441.441,0,0,1,.255.785",
    transform: "translate(-353.264 -401.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M463.686,525.119a8.543,8.543,0,1,1-8.543-8.543,8.543,8.543,0,0,1,8.543,8.543",
    transform: "translate(-399.971 -395.53)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M467.752,529.7l-2.994,2.382a.292.292,0,0,0-.1.306l1.022,3.687a.44.44,0,0,1-.668.485l-3.191-2.112a.291.291,0,0,0-.322,0l-3.191,2.112a.441.441,0,0,1-.668-.485l1.022-3.687a.291.291,0,0,0-.1-.306L455.57,529.7a.441.441,0,0,1,.255-.785l3.823-.167a.292.292,0,0,0,.26-.189l1.34-3.584a.441.441,0,0,1,.825,0l1.34,3.584a.292.292,0,0,0,.26.189l3.823.167a.441.441,0,0,1,.255.785",
    transform: "translate(-406.489 -401.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11298",
    "data-name": "Path 11298",
    d: "M535.571,525.119a8.543,8.543,0,1,1-8.543-8.543,8.543,8.543,0,0,1,8.543,8.543",
    transform: "translate(-453.196 -395.53)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11299",
    "data-name": "Path 11299",
    d: "M539.637,529.7l-2.994,2.382a.292.292,0,0,0-.1.306l1.022,3.687a.441.441,0,0,1-.668.485l-3.191-2.112a.291.291,0,0,0-.322,0l-3.191,2.112a.441.441,0,0,1-.668-.485l1.023-3.687a.291.291,0,0,0-.1-.306l-2.994-2.382a.441.441,0,0,1,.255-.785l3.823-.167a.292.292,0,0,0,.26-.189l1.34-3.584a.441.441,0,0,1,.826,0l1.34,3.584a.292.292,0,0,0,.26.189l3.823.167a.441.441,0,0,1,.255.785",
    transform: "translate(-459.714 -401.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M607.456,525.119a8.543,8.543,0,1,1-8.543-8.543,8.543,8.543,0,0,1,8.543,8.543",
    transform: "translate(-506.421 -395.53)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11301",
    "data-name": "Path 11301",
    d: "M611.521,529.7l-2.994,2.382a.292.292,0,0,0-.1.306l1.022,3.687a.441.441,0,0,1-.668.485l-3.191-2.112a.291.291,0,0,0-.322,0l-3.191,2.112a.441.441,0,0,1-.668-.485l1.023-3.687a.291.291,0,0,0-.1-.306l-2.994-2.382a.441.441,0,0,1,.255-.785l3.823-.167a.292.292,0,0,0,.26-.189l1.34-3.584a.441.441,0,0,1,.826,0l1.34,3.584a.292.292,0,0,0,.26.189l3.823.167a.441.441,0,0,1,.255.785",
    transform: "translate(-512.939 -401.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11302",
    "data-name": "Path 11302",
    d: "M421.854,81.379a31,31,0,0,1-5.223,17.261c-.1.153-.208.307-.315.458-.2.284-.395.565-.6.842a31.112,31.112,0,0,1-23.911,12.549c-.358.007-.717.016-1.082.016-.86,0-1.712-.037-2.547-.106a31.075,31.075,0,0,1-22.857-13.033c-.232-.329-.456-.65-.673-.987-.078-.121-.155-.243-.231-.364q-.206-.322-.4-.652a31.126,31.126,0,1,1,57.838-15.984",
    transform: "translate(-335.556 -50.26)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11303",
    "data-name": "Path 11303",
    d: "M436.54,213.81l4.435-.425,11.877-.213,4.8.683-2.248,7.533-8.186,2.278-9.022-2.612Z",
    transform: "translate(-392.522 -170.884)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11304",
    "data-name": "Path 11304",
    d: "M461.908,187.991q-7.478,9.911-15.925,0a22.842,22.842,0,0,0,.531-3.032,21.971,21.971,0,0,0,.13-2.594c0-.444-.014-.887-.039-1.331q-.021-.407-.059-.814c.053-1.176.082-2.36.093-3.547h14.614q.017,1.768.1,3.524c-.022.246-.042.491-.057.735-.028.446-.042.893-.048,1.34a23.471,23.471,0,0,0,.13,2.642,22.046,22.046,0,0,0,.534,3.078",
    transform: "translate(-399.514 -143.859)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11305",
    "data-name": "Path 11305",
    d: "M445.336,102.047c0,3.38-.04,7.536-.289,11.035-.275,3.975-.819,7.108-1.861,7.291h0c-.01,0-.02,0-.031,0a.35.35,0,0,1-.064.007c-.306,0-.6-.014-.884-.041-4.2-.391-6.34-3.6-8.382-7.128a22.3,22.3,0,0,1-2.263-7.624,27.576,27.576,0,0,1-.271-3.544c0-4.787,1.658-8.979,4.991-11.324a11.592,11.592,0,0,1,6.751-1.977h.071c1,.041,2.235,5.976,2.235,13.3",
    transform: "translate(-388.634 -78.756)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11306",
    "data-name": "Path 11306",
    d: "M481.957,102.042a30.492,30.492,0,0,1-.652,5.762,18.739,18.739,0,0,1-1.886,5.412c-2.16,3.741-4.4,7.111-9.152,7.158-.034,0-.071,0-.109,0-.326,0-.6-.279-.842-.775-1.271-2.626-1.406-11.385-1.406-17.561,0-7.328,1.244-13.27,2.235-13.3h.071c7.858.034,11.741,5.973,11.741,13.3",
    transform: "translate(-415.749 -78.755)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11307",
    "data-name": "Path 11307",
    d: "M434.819,97.383c-1.072,1.148,1.4,2.645.356,4.051-2.643,3.573-3.719,9.156-3.719,9.156l-.821.983s-.039.154-.106.412a24.691,24.691,0,0,1-.441-3.321,48.107,48.107,0,0,1-.024-8.045c.229-2.193,2.947-1.962,4.755-3.236",
    transform: "translate(-387.604 -85.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11308",
    "data-name": "Path 11308",
    d: "M503.981,97.383c.7.745-.607,2.39,0,3.32,2.6,3.981,3.363,9.887,3.363,9.887l.821.983s.039.154.106.412a24.738,24.738,0,0,0,.441-3.321c.238-4.639-1.291-8.857-4.731-11.281",
    transform: "translate(-442.334 -85.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11309",
    "data-name": "Path 11309",
    d: "M430.27,98.877s-1.081-7.937,1.624-9.869c2.3-1.642,4.242-1.974,4.975-1.787,1.223.312.477,2.751.477,2.751s-4.969,5.026-6.032,8.89c-.224.815-.791-.668-1.045.015",
    transform: "translate(-387.722 -77.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11310",
    "data-name": "Path 11310",
    d: "M502.266,104.233s.458-7.388-2.033-8.632c-3.714-1.854-5.057,0-5.057,0s5.622,4.682,7.09,8.632",
    transform: "translate(-435.938 -83.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11311",
    "data-name": "Path 11311",
    d: "M454.666,84.293c.209,1.2.12,3.225-1,4.286-2.288,2.176-7.274,3.53-10.54,3.955s-8,.363-9.538-1.707c-.733-.989,1.06-4.768,1.951-6.853.71-1.661,3.983-3.691,9.066-3.691,8.614.242,9.865,2.9,10.058,4.01",
    transform: "translate(-390.212 -72.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11312",
    "data-name": "Path 11312",
    d: "M516.424,144.285c0,1.749-.176,3.166.754,3.166s2.25-1.374,2.45-3.332c.178-1.74-.09-3-1.519-3-.931,0-1.685,1.418-1.685,3.166",
    transform: "translate(-451.66 -117.534)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11313",
    "data-name": "Path 11313",
    d: "M427.569,144.285c0,1.749.176,3.166-.755,3.166s-2.25-1.374-2.45-3.332c-.178-1.74.09-3,1.519-3,.931,0,1.685,1.418,1.685,3.166",
    transform: "translate(-383.472 -117.534)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11314",
    "data-name": "Path 11314",
    d: "M430.057,220.914c-.2.284-.395.565-.6.842a31.111,31.111,0,0,1-23.911,12.549c-.358.007-.717.016-1.082.016-.859,0-1.712-.037-2.547-.106a31.075,31.075,0,0,1-22.858-13.033c-.232-.329-.456-.65-.673-.987-.077-.121-.155-.243-.231-.364a10.491,10.491,0,0,1,6.678-3.814c.046-.007.085-.023.13-.03s.106-.007.159-.016c.456-.076.851-.113,1.149-.151.144-.016.28-.03.424-.053l5.441-.761c.5-.076.95-.145,1.314-.2.266-.046.41-.007.472.092a.5.5,0,0,1,.069.273c.053,2.819,6.216,7.613,9.734,7.613s9.681-4.795,9.741-7.613a.483.483,0,0,1,.062-.273c.069-.1.2-.137.47-.092.357.06.8.122,1.284.2.722.1,3.974.555,5.48.768.144.023.28.037.417.053.3.039.69.076,1.156.151.053.009.106.009.159.016s.092.023.13.03a10.435,10.435,0,0,1,7.427,4.9",
    transform: "translate(-349.297 -172.076)",
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11553",
    "data-name": "Path 11553",
    d: "M-18825.531-22070.018",
    transform: "translate(0 -3.401)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11555",
    "data-name": "Path 11555",
    d: "M263.068,122.458c-4.061,2.328-10.836-4.3-10.836-4.3s3.161,2.849,6.88,2.849,7.7-2.9,7.7-2.9v2.255",
    transform: "translate(-19019.078 -22177.916)",
    fill: "#ed975d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateCandidate);
export default __webpack_public_path__ + "static/media/rate-candidate.8c4a9d5a7fef241db2deec4cfada8582.svg";
export { ForwardRef as ReactComponent };